import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  CaretDownOutlined,
  WarningOutlined,
  DownOutlined,
} from "@ant-design/icons";
// import { RangeStepInput } from "react-range-step-input";
// import FileSaver from "file-saver";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { DatePicker, Modal } from "antd";
// import { useHistory } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import moment from "moment";
import { toast } from "react-toastify";
import {
  UserAddOutlined,
  UserOutlined,
  EditOutlined,
  DeleteOutlined,
  FolderOpenOutlined,
} from "@ant-design/icons";
import { Card, Space, Slider, Input, Button, Dropdown } from "antd";
import { Select, Table as AntTable, Switch } from "antd";
import Main from "../components/layout/Main";
import edit from "../assets/images/edit.svg";
import Header from "../components/layout/Header";
// import { useCurrentPng } from "recharts-to-png";
import { get, post } from "../Libraries/Ajax/HttpService";
import back from "../assets/images/back.svg";

import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useDistrict } from "../utils/DistrictContext";
import axios from "axios";
function MeterHistory() {
  // let history = useHistory();
  const navigate = useNavigate();
  var mcdata = JSON.parse(localStorage.getItem("MCData"));
  const [optionone, setOptionone] = useState("total");
  const [datas, setDatas] = useState([]);
  const [meterLogList, setMeterlogList] = useState([]);
  const [loading, setloading] = useState(true);
  const [open, setOpen] = useState(false);
  const [accountId, setaccountId] = useState("");
  const [metertId, setmeterId] = useState("");
  const [registerNo, setregisterNo] = useState("");
  const [accountName, setAccountName] = useState("");
  const [metertStatus, setmetertStatus] = useState("");
  const [replacedMeterid, setreplacedMeterid] = useState("");
  const [replacedRegId, setreplacedRegId] = useState("");
  const [isReplaced, setisReplaced] = useState(false);
  const [openConfirm, setopenConfirm] = useState(false);
  const [finalConfirm, setfinalConfirm] = useState(false);
  const [flowStartDate, setflowStartDate] = useState("");
  const [flowEndDate, setflowEndDate] = useState("");
  const [addressLine1, setaddressLine1] = useState("");
  const [addressLine2, setaddressLine2] = useState("");
  const [addressLine3, setaddressLine3] = useState("");
  const [addressCity, setaddressCity] = useState("");
  const [addressDistrict, setaddressDistrict] = useState("");
  const [addressCountry, setaddressCountry] = useState("");
  const [locationId, setlocationId] = useState("");
  const [meterlogId, setmeterLogId] = useState("");
  const [replacedFullmeterid, setreplacedFullmeterid] = useState("");
  const [replacedMeterList, setreplacedMeterLsit] = useState([]);
  const [switchDisable, setSwitchdisable] = useState(false);
  const [meterlistloading, setmeterlistloading] = useState(false);
  const [openRow, setOpenRow] = useState(null);
  const { selectedDistrict } = useDistrict();

  const [meterRows, setMeterRows] = useState([]);
  const [meterLoading, setMeterLoading] = useState(false);
  const [meterExpanded, setMeterExpanded] = useState(false);

  // [
  //     {
  //         "account_id": "139255",
  //         "changed": "New",
  //         "code": "WELL",
  //         "code_name": "Generation Park Well",
  //         "created_at": "Tuesday, May 28, 2024 10:09 AM",
  //         "end_date": "Tuesday, May 28, 2024 05:44 AM",
  //         "first_account_id": "139255",
  //         "first_location_id": "80304",
  //         "first_meter_id": "101893",
  //         "first_register_number": "",
  //         "location_address_line1": "11311 1/2 W LAKE HOUSTON PKWY",
  //         "location_address_line2": "WELL METER",
  //         "location_address_line3": "nan",
  //         "location_city": "HOUSTON",
  //         "location_country": "US",
  //         "location_district": "nan",
  //         "location_id": "80304",
  //         "meter_id": "101893",
  //         "meter_log_id": 1,
  //         "overided_name": "Well",
  //         "register_number": "",
  //         "replaced_account_id": "",
  //         "replaced_location_id": "",
  //         "replaced_meter_id": "",
  //         "replaced_register_number": "",
  //         "start_date": "Tuesday, Jun 25, 2019 01:59 PM"
  //     }
  // ]
  const columns = [
    // {
    //   title: 'Type',
    //   dataIndex: 'type',
    //   key: 'type'
    // },
    // {
    //   title: 'Frequency',
    //   dataIndex: 'frequency',
    //   key: 'frequency'
    // },
    {
      title: "Meter Id",
      dataIndex: "meter_id",
      key: "meter_id",
    },
    {
      title: "Register No",
      dataIndex: "register_number",
      key: "register_number",
    },

    {
      title: "Status",
      dataIndex: "changed",
      key: "unit",
    },
    {
      title: "Account Id",
      dataIndex: "account_id",
      key: "value",
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "display_name",
    },
    {
      title: "Account Name",
      dataIndex: "overided_name",
      key: "account_name",
    },
    // {
    //     title: 'Created At',
    //     dataIndex: 'created_at',
    //     key: 'created_at',
    //   },
    //   {
    //     title: 'Location Address Line 1',
    //     dataIndex: 'location_address_line1',
    //     key: 'location_address_line1',

    //   },
    {
      title: "Location City",
      dataIndex: "location_city",
      key: "location_city",
    },
    {
      title: "Location Country",
      dataIndex: "location_country",
      key: "location_country",
    },
    {
      title: "Flow Start Date",
      dataIndex: "start_date",
      key: "start_date",
    },
    {
      title: "Flow End Date",
      dataIndex: "end_date",
      key: "end_date",
    },

    //   {
    //     title: 'Replaced Meter Id',
    //     dataIndex: 'replaced_meter_id',
    //     key: 'replaced_meter_id',

    //   },
    //   {
    //     title: 'Replaced Register No',
    //     dataIndex: 'replaced_register_number',
    //     key: 'replaced_register_number',

    //   },

    {
      title: "Edit",
      dataIndex: "action",
      align: "center",
      key: "id",
      onCell: (record) => {
        return {
          onClick: (ev) => {
            onEditClick(record);
          },
        };
      },
      render: (_, record) => (
        <Space>
          <img
            src={edit}
            alt="Edit"
            style={{ width: "25px", verticalAlign: "middle" }}
          />
        </Space>
      ),
    },
  ];

  // const rows = [
  //     createData('Generation Park', 159, 6.0, 24, 4.0, 3.99),
  //     createData('250 Assay Street', 237, 9.0, 37, 4.3, 4.99),
  //     createData('Lock Wood', 262, 16.0, 24, 6.0, 3.79),
  //     createData('GP Industrial', 305, 3.7, 67, 4.3, 2.5),
  //     createData('Well', 356, 16.0, 49, 3.9, 1.5),
  //   ];

  const handleRowClick = (name) => {
    setOpenRow(openRow === name ? null : name);
  };

  const renderRow = (row, index) => {
    const backgroundColorClass =
      index % 2 === 0 ? "bg-table-blue" : "white-background";
    return (
      <React.Fragment key={row.account}>
        <TableRow
          sx={{ "& > *": { borderBottom: "unset" }, borderRadius: "18px" }}
        >
          {/* <TableCell>
                  <IconButton
                    aria-label="expand row"
                    size="small"
                    onClick={() => handleRowClick(row.name)}
                  > 
                    {openRow === row.name ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                  </IconButton>
                </TableCell> */}
          <TableCell
            className={backgroundColorClass}
            component="th"
            onClick={() => handleRowClick(row.account)}
            scope="row"
          >
            {row.account}
          </TableCell>
          {/* <TableCell align="right">{row.calories}</TableCell>
                <TableCell align="right">{row.fat}</TableCell> */}
          {/* <TableCell align="right">{row.carbs}</TableCell>
                <TableCell align="right">{row.protein}</TableCell> */}
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={openRow === row.account} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Typography variant="h6" gutterBottom component="div">
                  Meters
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell>Meter Id</TableCell>
                      <TableCell>Register No</TableCell>
                      <TableCell>Meter Status</TableCell>
                      <TableCell>Flow Start Time</TableCell>
                      <TableCell>Flow End Time</TableCell>
                      <TableCell>Address</TableCell>
                      {/* <TableCell>Location Id </TableCell>
                            <TableCell align="right">Account Id</TableCell> */}
                      <TableCell align="right">Meter Code</TableCell>
                      <TableCell align="right">Meter Type</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row.meters.map((historyRow) => (
                      <TableRow key={historyRow.created_at}>
                        <TableCell component="th" scope="row">
                          {historyRow.meter_id}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {historyRow.register_number}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {/* {historyRow.changed == "Replaced"? `${historyRow.changed} -(${historyRow.replaced_meter_id},${historyRow.replaced_register_number})`: historyRow.changed == "Old" ? "Active" :`${historyRow.changed}`} */}
                          {historyRow.changed}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {historyRow.start_date}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {historyRow.end_date}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {/* {historyRow.location_address_line1}  */}
                          {[
                            historyRow.location_address_line1,
                            historyRow.location_address_line2,
                            historyRow.location_city,
                            historyRow.location_district,
                            historyRow.location_country,
                          ]
                            .filter(
                              (item) => item && item.toLowerCase() !== "nan"
                            )
                            .join(", ")}
                        </TableCell>
                        {/* <TableCell>{historyRow.location_id} </TableCell>
                              <TableCell align="right">{historyRow.account_id}</TableCell> */}
                        <TableCell align="right">{historyRow.code}</TableCell>
                        <TableCell align="right">
                          {historyRow.code_name}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  };

  useEffect(() => {
    get(`apis/meter_new_list`).then((response) => {
      if (response.status === 200) {
        setTimeout(() => {
          // console.log(response.data);
          setDatas(response.data.data);
        }, 1000);
      }
    });

    get(`apis/account_based_meter_log_list`).then((response) => {
      if (response.status === 200) {
        setTimeout(() => {
          // console.log(response.data);
          setMeterlogList(response.data.data);
        }, 1000);
      }
    });
  }, [selectedDistrict]);

  useEffect(() => {
    if (open) {
      setreplacedMeterLsit(true);
      console.log("meter Log id", meterlogId);
      get(
        `apis/account_based_meter_list?meter_log_id=${meterlogId}&account_id=${accountId}`
      ).then((response) => {
        if (response.status === 200) {
          setmeterlistloading(false);
          setTimeout(() => {
            // console.log(response.data);
            setreplacedMeterLsit(response.data.data);
            if (response.data.data.length == 0) {
              setSwitchdisable(true);
              setisReplaced(false);
            } else {
              setSwitchdisable(false);
            }
            // setreplacedMeterLsit([
            //     {
            //         "meter": "116084,H"
            //     },
            //     {
            //         "meter": "116085"
            //     }s
            // ],)
          }, 1000);
        }
      });
    }
  }, [open, selectedDistrict]);
  // useEffect(() => {
  //       const isMizuWatch = window.location.href.includes("mizuwatch.com");
  //       document.title = isMizuWatch ? "MizuWatch" : "MizuSmart";
  //     }, []);
  useEffect(() => {
    if (finalConfirm) {
      let data = {};

      if (isReplaced) {
        data = {
          changed: "Replaced",
          meter_id: metertId,
          register_number: registerNo,
          account_id: accountId,
          location_id: locationId,
          meter_log_id: meterlogId,
          replaced_meter_id: replacedMeterid,
          replaced_register_number: replacedRegId,
        };
        console.log(" not empty data is", data);
      } else {
        setregisterNo("");
        setreplacedMeterid("");

        data = {
          changed: "Not Replaced",
          meter_id: metertId,
          register_number: registerNo,
          account_id: accountId,
          location_id: locationId,
          meter_log_id: meterlogId,
          replaced_meter_id: "",
          replaced_register_number: "",
        };
      }

      post("apis/meter_new_list", data).then(
        (response) => {
          setTimeout(() => {
            toast.success(response.data.message);
          }, 1000);

          setTimeout(() => {
            history.go(0);
          }, 2000);
        },
        (error) => {
          toast.error(error.response.data.msg, {
            autoClose: 3000,
          });
        }
      );
    }
  }, [finalConfirm, selectedDistrict]);

  const onEditClick = (record) => {
    setAccountName(record.code_name);
    setmeterId(record.meter_id);
    setregisterNo(record.register_number);
    setmetertStatus(record.changed);
    setaccountId(record.account_id);
    setflowEndDate(record.end_date);
    setflowStartDate(record.start_date);
    setaddressLine1(record.location_address_line1);
    setaddressLine2(record.location_address_line2);
    setaddressLine3(record.location_address_line3);
    setaddressCity(record.location_city);
    setaddressDistrict(record.location_district);
    setaddressCountry(record.location_country);
    setlocationId(record.location_id);
    setmeterLogId(record.meter_log_id);
    setisReplaced(false);
    setreplacedMeterid("");
    setreplacedRegId("");
    setreplacedFullmeterid("");
    setreplacedMeterLsit([]);
    setOpen(true);
    setSwitchdisable(false);

    console.log("record is printed", record.location_city);
    // console.log(override);
  };

  const onclickreplaceddropdown = () => {
    if (replacedMeterList.length == 0) {
      console.log("flase");
      setisReplaced(false);
    }
  };

  const onChangeReplacedfullmeterid = (e) => {
    if (replacedMeterList.length == 0) {
      setisReplaced(false);
    }
    const temp_val = e.target.value.trim(); // Remove any leading/trailing whitespace
    setreplacedFullmeterid(temp_val);
    console.log(temp_val);

    if (temp_val.includes(",")) {
      const [meterId, regId] = temp_val.split(",");
      setreplacedMeterid(meterId.trim()); // Trim any leading/trailing whitespace
      setreplacedRegId(regId.trim());
    } else {
      setreplacedMeterid(temp_val.trim());
      setreplacedRegId(""); // Clear register ID if comma is not present
    }
  };

  const OnchangeReplacedMeterID = (event) => {
    console.log(event.target.value);
    setreplacedMeterid(event.target.value);
  };
  const OnchangeReplacedRegNo = (event) => {
    console.log(event.target.value);
    setreplacedRegId(event.target.value);
  };
  const handleSave = () => {
    if (isReplaced) {
      if (replacedMeterid !== "" || replacedRegId !== "") {
        setopenConfirm(true);
      } else {
        toast.error("Please provide replaced meter details", {
          autoClose: 3000,
        });
      }
    } else {
      setopenConfirm(true);
    }
  };
  const handleCancelConfirm = () => {
    setopenConfirm(false);
  };
  const handleFinalConfirm = () => {
    console.log("final");
    setfinalConfirm(true);
    setopenConfirm(false);
    setOpen(false);
  };

  const onselectClick = () => {
    navigate("/settingsuser");
  };
  const onselectClicks = () => {
    navigate("/list");
  };
  const onselectClickaccount = () => {
    navigate("/accountnames");
  };
  const onselectMetermangement = () => {
    navigate("/metermanagement");
  };

  const onselectMeterHistory = () => {
    navigate('/meterhistory');
  }
  const onselectClickss = () => {
    // history.push('/dashboard');
    // window.history.back();
    navigate(-1);
  };
  const handleCancelEdit = () => {
    setOpen(false);
  };
  const onChangeSwitch = (checked) => {
    console.log(`switch to ${checked}`);
    setisReplaced(checked);
  };

  //   useEffect(() => {
  //     const fetchData = async () => {
  //       try {
  //         setMeterLoading(true);
  //         const res = await axios.get("http://192.168.96.120:5000/apis/changelog");
  //         const data = res.data || [];

  //         const formatted = data.map(item => {
  //           const date = new Date(item.changed_at).toLocaleString(); // format date
  //           const updates = [];

  //           // Loop over column_diffs
  //           for (let key in item.column_diffs) {
  //             const diff = item.column_diffs[key];
  //             if (diff.old === null) {
  //               updates.push(`${key}: ${diff.new} (added)`);
  //             } else if (diff.new === null) {
  //               updates.push(`${key}: ${diff.old} → deleted`);
  //             } else {
  //               updates.push(`${key}: ${diff.old} → ${diff.new}`);
  //             }
  //           }

  //           return { date, updates };
  //         });

  //         setMeterRows(formatted);
  //       } catch (err) {
  //         console.error("Error fetching changelog:", err);
  //       } finally {
  //         setMeterLoading(false);
  //       }
  //     };

  //     fetchData();
  //   }, []);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       setMeterLoading(true);
  //       const res = await axios.get("http://192.168.96.120:5000/apis/changelog");
  //       const data = res.data || [];

  //       const formatted = data.map(item => {
  //         const date = new Date(item.changed_at).toLocaleString(); 
  //         const updates = [];


  //         for (let key in item.column_diffs) {
  //           const diff = item.column_diffs[key];
  //           if (diff.old === null) {
  //             updates.push(
  //               <span key={key}>
  //                 {key}: <b>{diff.new}</b>
  //               </span>
  //             );
  //           } else if (diff.new === null) {
  //             updates.push(
  //               <span key={key}>
  //                 {key}: {diff.old} → <b>deleted</b>
  //               </span>
  //             );
  //           } else {
  //             updates.push(
  //               <span key={key}>
  //                 {key}: {diff.old} → <b>{diff.new}</b>
  //               </span>
  //             );
  //           }
  //         }

  //         return {
  //           date,
  //           updates,
  //           meterId: item.entity_pk?.account_id || "-", 
  //           updateType: item.change_type || "-",        
  //         };
  //       });

  //       setMeterRows(formatted);
  //     } catch (err) {
  //       console.error("Error fetching changelog:", err);
  //     } finally {
  //       setMeterLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, []);

  useEffect(() => {
  const fetchData = async () => {
    try {
      setMeterLoading(true);
      const res = await get("apis/changelog");
      const data = res.data || [];

      const formatted = data.map((item) => {
        const rawDate = new Date(item.changed_at);
        const date = rawDate.toLocaleString(); // human readable
        const updates = [];

        for (let key in item.column_diffs) {
          const diff = item.column_diffs[key];
          if (diff?.old === null) {
            updates.push(
              <span key={key}>
                {key}: <b>{diff?.new}</b>
              </span>
            );
          } else if (diff?.new === null) {
            updates.push(
              <span key={key}>
                {key}: {diff?.old} → <b>deleted</b>
              </span>
            );
          } else {
            updates.push(
              <span key={key}>
                {key}: {diff?.old} → <b>{diff?.new}</b>
              </span>
            );
          }
        }

        return {
          rawDate,                            // ← keep raw for sorting
          date,                               // formatted for display
          updates,
          meterId: item.entity_pk?.account_id ?? "-",
          updateType: item.change_type ?? "-",
        };
      });

      // newest first
      formatted.sort((a, b) => b.rawDate - a.rawDate);

      setMeterRows(formatted);
    } catch (err) {
      console.error("Error fetching changelog:", err);
    } finally {
      setMeterLoading(false);
    }
  };

  fetchData();
}, []);


  useEffect(() => {
    console.log("meter rows updated:", meterRows);
  }, [meterRows]);



  return (
    <>
      <Header />
      <Main>
        <div>
          <div className="d-flex ">
            <img
              src={back}
              alt=""
              style={{ width: "10px", cursor: "pointer" }}
              onClick={onselectClickss}
            />
            <div className="d-flex align-items-center">
              {mcdata.mcdatas.type === "U" && mcdata.mcdatas.type === "U" ? (
                ""
              ) : (
                <>
                  <div
                    className="new-box-padding   align-self-center c-pointer"
                    style={{
                      borderBottom: "2px solid #ccc ",
                      borderRadius: "0",
                    }}
                    onClick={onselectClick}
                  >
                    {" "}
                    Settings
                  </div>
                  <div
                    className=""
                    style={{ width: "2px", height: "25px", background: "#ccc" }}
                  ></div>
                </>
              )}

              {mcdata.mcdatas.type === "U" && mcdata.mcdatas.type === "U" ? (
                ""
              ) : (
                <>

                  <div
                    className="new-box-padding   align-self-center c-pointer "
                    onClick={onselectClicks}
                    style={{
                      borderBottom: "2px solid #ccc",
                    }}
                  >
                    {" "}
                    Users
                  </div>
                </>
              )}

              <div
                className=""
                style={{ width: "2px", height: "25px", background: "#ccc" }}
              ></div>
              <div
                className="new-box-padding   align-self-center c-pointer "
                onClick={onselectClickaccount}
                style={{
                  borderBottom: "2px solid #ccc",
                }}
              >
                {" "}
                Accounts
              </div>
              {mcdata.mcdatas.type === "U" && mcdata.mcdatas.type === "U" ? (
                ""
              ) : (
                <>
                  {/* <div
                    className=""

                    style={{ width: "2px", height: "25px", background: "#ccc" }}
                  ></div>
                  <div
                    className="new-box-padding align-self-center c-pointer  "
                    style={{
                      borderBottom: "2px solid #ccc",
                    }}
                    onClick={onselectMetermangement}
                  >
                    {" "}
                    Meter Management
                  </div> */}
                </>
              )}
              {mcdata.mcdatas.type === "U" && mcdata.mcdatas.type === "U" ? (
                ""
              ) : (
                <>
                  {/* <div
                    className=""

                    style={{ width: "2px", height: "25px", background: "#1998f0" }}
                  ></div>
                  <div
                    className="new-box-padding text-blue   align-self-center c-pointer  "
                    style={{
                      borderBottom: "2px solid #1998f0",
                    }}
                    onClick={onselectMeterHistory}
                  >
                    {" "}
                    Meter History
                  </div> */}
                </>
              )}
            </div>
          </div>
          {/* <h4 class ="text-blue mt-5 fw-bold mb-4 px-2">Meters</h4> */}
          <div className="d-flex align-items-center justify-content-between flex-wrap ">


            {/* // Meter Tab */}
            <div className="w-100">
              <h4 class="text-blue mb-0 mt-5 fw-bold mb-4 px-2">Meter</h4>

              <div style={{ background: "#fff", borderRadius: 15, padding: "12px 10px" }}>
                {/* Title row like your screenshot */}

                {meterLoading ? (
                  <div style={{ padding: 16 }}>Loading…</div>
                ) : meterRows.length === 0 ? (
                  <div style={{ padding: 16, display: "flex", alignItems: "center", gap: 8 }}>
                    <FolderOpenOutlined />
                    <span>Data not available</span>
                  </div>
                ) : (
                  <div style={{ overflowX: "auto" }}>
                    {/* <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            borderSpacing: 0,
            borderRadius: 12,
            overflow: "hidden",
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  textAlign: "left",
                  padding: "12px 16px",
                  background: "#f5f8fe",
                  fontWeight: 700,
                  color: "#0f294d",
                  borderBottom: "1px solid #e9eef7",
                  width: "28%",
                  whiteSpace: "nowrap",
                }}
              >
                Date
              </th>
            <th
                style={{
                  textAlign: "left",
                  padding: "12px 16px",
                  background: "#f5f8fe",
                  fontWeight: 700,
                  color: "#0f294d",
                  borderBottom: "1px solid #e9eef7",
                }}
              >
                Meter ID
              </th>
            <th
                style={{
                  textAlign: "left",
                  padding: "12px 16px",
                  background: "#f5f8fe",
                  fontWeight: 700,
                  color: "#0f294d",
                  borderBottom: "1px solid #e9eef7",
                }}
              >
                Update Type
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "12px 16px",
                  background: "#f5f8fe",
                  fontWeight: 700,
                  color: "#0f294d",
                  borderBottom: "1px solid #e9eef7",
                }}
              >
                Values
              </th>

            </tr>
          </thead>

          <tbody>
  {meterRows.map((r, i) => (
    <tr key={i} style={{ background: i % 2 ? "#f6fbff" : "#fff" }}>
      <td style={{ padding: "12px 16px", borderBottom: "1px solid #eef2f7", whiteSpace: "nowrap" }}>
        {r.date}
      </td>
      <td style={{ padding: "12px 16px", borderBottom: "1px solid #eef2f7" }}>
        {r.meterId}
      </td>
      <td style={{ padding: "12px 16px", borderBottom: "1px solid #eef2f7" }}>
        {r.updateType}
      </td>
      <td style={{ padding: "12px 16px", borderBottom: "1px solid #eef2f7" }}>
        <ul style={{ margin: 0, paddingLeft: 18 }}>
          {r.updates.map((u, idx) => (
            <li key={idx}>{u}</li>
          ))}
        </ul>
      </td>
    </tr>
  ))}
</tbody>

        </table> */}
                  </div>
                )}
              </div>
            </div>


            {/* // Account Tab */}
            <div className="w-100">
              <h4 class="text-blue mb-0 fw-bold mb-4 px-2">Account</h4>

              {/* {meterLogList.length > 0 ? (
              <div style={{background: '#fff', padding: '12px 10px', borderRadius: '15px'}}>
                <TableContainer component={Paper} className="">
                  <Table aria-label="collapsible table">
                    
                    <TableBody>
                      {meterLogList.map((row, index) => renderRow(row, index))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            ) : (
              <div className="no-found w-100 text-center">
                <div className="w-100 text-center">
                  <FolderOpenOutlined />
                  <span className="found-text text-center">No data Found</span>
                </div>
              </div>
            )} */}

              {/* {meterLoading ? (
                <div style={{ padding: 16 }}>Loading…</div>
              ) : meterRows.length === 0 ? (
                <div style={{ padding: 16, display: "flex", alignItems: "center", gap: 8 }}>
                  <FolderOpenOutlined />
                  <span>Data not available</span>
                </div>
              ) : (
                <div style={{ overflowX: "auto" }}>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      borderSpacing: 0,
                      borderRadius: 12,
                      overflow: "hidden",
                    }}
                  >
                    <thead>
                      <tr>
                        <th
                          style={{
                            textAlign: "left",
                            padding: "12px 16px",
                            background: "#f5f8fe",
                            fontWeight: 700,
                            color: "#0f294d",
                            borderBottom: "1px solid #e9eef7",
                            width: "28%",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Date
                        </th>
                        <th
                          style={{
                            textAlign: "left",
                            padding: "12px 16px",
                            background: "#f5f8fe",
                            fontWeight: 700,
                            color: "#0f294d",
                            borderBottom: "1px solid #e9eef7",
                          }}
                        >
                          Account ID
                        </th>
                        <th
                          style={{
                            textAlign: "left",
                            padding: "12px 16px",
                            background: "#f5f8fe",
                            fontWeight: 700,
                            color: "#0f294d",
                            borderBottom: "1px solid #e9eef7",
                          }}
                        >
                          Update Type
                        </th>
                        <th
                          style={{
                            textAlign: "left",
                            padding: "12px 16px",
                            background: "#f5f8fe",
                            fontWeight: 700,
                            color: "#0f294d",
                            borderBottom: "1px solid #e9eef7",
                          }}
                        >
                          Values
                        </th>

                      </tr>
                    </thead>

                    <tbody>
                      {meterRows.map((r, i) => (
                        <tr key={i} style={{ background: i % 2 ? "#f6fbff" : "#fff" }}>
                          <td style={{ padding: "12px 16px", borderBottom: "1px solid #eef2f7", whiteSpace: "nowrap" }}>
                            {r.date}
                          </td>
                          <td style={{ padding: "12px 16px", borderBottom: "1px solid #eef2f7" }}>
                            {r.meterId}
                          </td>
                          <td style={{ padding: "12px 16px", borderBottom: "1px solid #eef2f7" }}>
                            {r.updateType}
                          </td>
                          <td style={{ padding: "12px 16px", borderBottom: "1px solid #eef2f7" }}>
                            <ul style={{ margin: 0, paddingLeft: 0 }}>
                              {r.updates.map((u, idx) => (
                                <li key={idx}>{u}</li>
                              ))}
                            </ul>
                          </td>
                        </tr>
                      ))}
                    </tbody>

                  </table>
                </div>
              )} */}

               {meterLoading ? (
    <div style={{ padding: 16 }}>Loading…</div>
  ) : meterRows.length === 0 ? (
    <div style={{ padding: 16, display: "flex", alignItems: "center", gap: 8 }}>
      <FolderOpenOutlined />
      <span>Data not available</span>
    </div>
  ) : (
    <div 
    // style={{ overflowX: "auto" }}
    style={{
    overflowX: "auto",
    overflowY: "auto",            // keep a vertical scrollbar context
    maxHeight: 460,               // any value that fits your layout
    scrollbarGutter: "stable",    // reserve gutter so width doesn’t change
  }}
    >
      <table
        // style={{
        //   width: "100%",
        //   borderCollapse: "collapse",
        //   borderSpacing: 0,
        //   borderRadius: 12,
        //   overflow: "hidden",
        // }}
        style={{
          width: "100%",
          borderCollapse: "collapse",
          borderSpacing: 0,
          borderRadius: 12,
          overflow: "hidden",
          tableLayout: "fixed",       // lock column widths
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                textAlign: "left",
                padding: "12px 16px",
                background: "#f5f8fe",
                fontWeight: 700,
                color: "#0f294d",
                borderBottom: "1px solid #e9eef7",
                width: "28%",
                whiteSpace: "nowrap",
              }}
            >
              Activity Date
            </th>
            <th
              style={{
                textAlign: "left",
                padding: "12px 16px",
                background: "#f5f8fe",
                fontWeight: 700,
                color: "#0f294d",
                borderBottom: "1px solid #e9eef7",
              }}
            >
              Account ID
            </th>
            <th
              style={{
                textAlign: "left",
                padding: "12px 16px",
                background: "#f5f8fe",
                fontWeight: 700,
                color: "#0f294d",
                borderBottom: "1px solid #e9eef7",
              }}
            >
              Update Type
            </th>
            <th
              style={{
                textAlign: "left",
                padding: "12px 16px",
                background: "#f5f8fe",
                fontWeight: 700,
                color: "#0f294d",
                borderBottom: "1px solid #e9eef7",
              }}
            >
              Changes
            </th>
          </tr>
        </thead>

        <tbody>
          {/* latest row (always visible) */}
          {(() => {
            const latest = meterRows[0];
            const rest = meterRows.slice(1);

            return (
              <>
                <tr
                  onClick={() => setMeterExpanded((v) => !v)}
                  style={{
                    background: "#fff",
                    cursor: "pointer",
                  }}
                  aria-expanded={meterExpanded}
                >
                  <td
                    style={{
                      padding: "12px 16px",
                      borderBottom: "1px solid #eef2f7",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {latest.date}
                  </td>
                  <td
                    style={{
                      padding: "12px 16px",
                      borderBottom: "1px solid #eef2f7",
                    }}
                  >
                    {latest.meterId}
                  </td>
                  <td
                    style={{
                      padding: "12px 16px",
                      borderBottom: "1px solid #eef2f7",
                    }}
                  >
                    {latest.updateType}
                  </td>
                  <td
                    style={{
                      padding: "12px 16px",
                      borderBottom: "1px solid #eef2f7",
                    }}
                  >
                    <ul style={{ margin: 0, paddingLeft: 0 }}>
                      {latest.updates.map((u, idx) => (
                        <li key={idx}>{u}</li>
                      ))}
                    </ul>
                  </td>
                </tr>

                {/* remaining rows (only when expanded) */}
                {meterExpanded &&
                  rest.map((r, i) => (
                    <tr
                      key={i}
                      style={{
                        background: i % 2 ? "#f6fbff" : "#fff",
                      }}
                    >
                      <td
                        style={{
                          padding: "12px 16px",
                          borderBottom: "1px solid #eef2f7",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {r.date}
                      </td>
                      <td
                        style={{
                          padding: "12px 16px",
                          borderBottom: "1px solid #eef2f7",
                        }}
                      >
                        {r.meterId}
                      </td>
                      <td
                        style={{
                          padding: "12px 16px",
                          borderBottom: "1px solid #eef2f7",
                        }}
                      >
                        {r.updateType}
                      </td>
                      <td
                        style={{
                          padding: "12px 16px",
                          borderBottom: "1px solid #eef2f7",
                        }}
                      >
                        <ul style={{ margin: 0, paddingLeft: 0 }}>
                          {r.updates.map((u, idx) => (
                            <li key={idx}>{u}</li>
                          ))}
                        </ul>
                      </td>
                    </tr>
                  ))}
              </>
            );
          })()}
        </tbody>
      </table>
    </div>
  )}
            </div>


            {/* // Location Tab */}

            <div className="w-100">
              <h4 class="text-blue mb-0 fw-bold mb-4 px-2">Location</h4>



              {meterLoading ? (
                <div style={{ padding: 16 }}>Loading…</div>
              ) : meterRows.length === 0 ? (
                <div style={{ padding: 16, display: "flex", alignItems: "center", gap: 8 }}>
                  <FolderOpenOutlined />
                  <span>Data not available</span>
                </div>
              ) : (
                <div style={{ overflowX: "auto" }}>
                  {/* <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            borderSpacing: 0,
            borderRadius: 12,
            overflow: "hidden",
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  textAlign: "left",
                  padding: "12px 16px",
                  background: "#f5f8fe",
                  fontWeight: 700,
                  color: "#0f294d",
                  borderBottom: "1px solid #e9eef7",
                  width: "28%",
                  whiteSpace: "nowrap",
                }}
              >
                Date
              </th>
            <th
                style={{
                  textAlign: "left",
                  padding: "12px 16px",
                  background: "#f5f8fe",
                  fontWeight: 700,
                  color: "#0f294d",
                  borderBottom: "1px solid #e9eef7",
                }}
              >
                Meter ID
              </th>
            <th
                style={{
                  textAlign: "left",
                  padding: "12px 16px",
                  background: "#f5f8fe",
                  fontWeight: 700,
                  color: "#0f294d",
                  borderBottom: "1px solid #e9eef7",
                }}
              >
                Update Type
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "12px 16px",
                  background: "#f5f8fe",
                  fontWeight: 700,
                  color: "#0f294d",
                  borderBottom: "1px solid #e9eef7",
                }}
              >
                Values
              </th>

            </tr>
          </thead>

          <tbody>
  {meterRows.map((r, i) => (
    <tr key={i} style={{ background: i % 2 ? "#f6fbff" : "#fff" }}>
      <td style={{ padding: "12px 16px", borderBottom: "1px solid #eef2f7", whiteSpace: "nowrap" }}>
        {r.date}
      </td>
      <td style={{ padding: "12px 16px", borderBottom: "1px solid #eef2f7" }}>
        {r.meterId}
      </td>
      <td style={{ padding: "12px 16px", borderBottom: "1px solid #eef2f7" }}>
        {r.updateType}
      </td>
      <td style={{ padding: "12px 16px", borderBottom: "1px solid #eef2f7" }}>
        <ul style={{ margin: 0, paddingLeft: 18 }}>
          {r.updates.map((u, idx) => (
            <li key={idx}>{u}</li>
          ))}
        </ul>
      </td>
    </tr>
  ))}
</tbody>

        </table> */}
                </div>
              )}
            </div>


          </div>
        </div>
      </Main>
    </>
  );
}

export default MeterHistory;
